import { h } from "preact";

import IconProps from "./IconProps";

function IconChevron({ class: cssClass, color, width, height }: IconProps) {
    return (
        <svg class={cssClass} width={width} height={height} viewBox="0 0 8 8">
            <path fill={color} fill-rule="nonzero" d="M3.568 6.26L.938 1.752A.5.5 0 0 1 1.372 1h5.258a.5.5 0 0 1 .432.752L4.431 6.26a.5.5 0 0 1-.863 0z"/>
        </svg>
    );
}

IconChevron.defaultProps = {
    color: "var(--teflon)",
    width: 8,
    height: 8
};

export default IconChevron;
